"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "orsogna": {
    "c999f4d0": [{
      "hkey": "d63ae5f3",
      "slug": "orsogna",
      "name": "Orsogna",
      "primary": true,
      "skipSearch": false
    }],
    "feuduccio": [{
      "hkey": "d63ae5f3",
      "slug": "orsogna",
      "name": "Orsogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "37324283": [{
      "hkey": "d63ae5f3",
      "slug": "orsogna",
      "name": "Orsogna",
      "primary": true,
      "skipSearch": false
    }],
    "sterparo": [{
      "hkey": "d63ae5f3",
      "slug": "orsogna",
      "name": "Orsogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d37a3bdb": [{
      "hkey": "d63ae5f3",
      "slug": "orsogna",
      "name": "Orsogna",
      "primary": true,
      "skipSearch": false
    }],
    "valli-coste-di-moro": [{
      "hkey": "d63ae5f3",
      "slug": "orsogna",
      "name": "Orsogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;